import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CompanyResponse, MarketDealResponse } from '../../../../@shared/models/response.module';
import { EndpointService } from '../../../../@shared/endpoints.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AddDeal } from './components/add-deal/add-deal';
import { DeleteModal } from '../../../../@shared/components/delete-modal/delete-modal';
import { ToastService } from '../../../../@core/services/toast.service';

@Component({
  selector: 'app-company-profile-deals',
  standalone: false,
  templateUrl: './company-profile-deals.html',
  styleUrl: './company-profile-deals.css'
})
export class CompanyProfileDeals implements OnChanges {
  @Input() company: CompanyResponse;

  deals: MarketDealResponse[] = [];
  loading: boolean = false;

  constructor(
    private endpointService: EndpointService,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private toastService: ToastService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['company'] && this.company?.company_id) {
      this.getDeals();
    }
  }

  getDeals() {
    if (!this.company?.company_id) {
      return;
    }
    this.loading = true;
    this.endpointService.cor_coy_50({ company_id: this.company.company_id }).subscribe({
      next: (res) => {
        this.deals = res.data || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.deals = [];
      }
    });
  }

  openAddModal() {
    const modalRef = this.modalService.open(AddDeal, { size: 'lg', centered: true });
    modalRef.componentInstance.company = this.company;
    modalRef.result.then((result) => {
      if (result) {
        this.getDeals();
      }
    }).catch(() => {});
  }

  openEditModal(deal: MarketDealResponse) {
    const modalRef = this.modalService.open(AddDeal, { size: 'lg', centered: true });
    modalRef.componentInstance.company = this.company;
    modalRef.componentInstance.editMode = true;
    modalRef.componentInstance.deal = deal;
    modalRef.result.then((result) => {
      if (result) {
        this.getDeals();
      }
    }).catch(() => {});
  }

  deleteDeal(deal: MarketDealResponse) {
    const modalRef = this.modalService.open(DeleteModal, { centered: true });
    modalRef.componentInstance.description = this.translateService.instant('companyProfile.deals.deleteConfirm');
    modalRef.result.then((result) => {
      if (result) {
        this.endpointService.cor_coy_53(deal.deal_id, { company_id: this.company.company_id }).subscribe({
          next: () => {
            this.toastService.success(this.translateService.instant('companyProfile.deals.deleteSuccess'));
            this.getDeals();
          },
          error: (err) => {
            console.error('Error deleting deal:', err);
            this.toastService.error(this.translateService.instant('companyProfile.deals.deleteError'));
          }
        });
      }
    }).catch(() => {});
  }

  isDealActive(deal: MarketDealResponse): boolean {
    const now = new Date();
    const startDate = new Date(deal.start_date);
    const endDate = new Date(deal.end_date);
    return deal.is_active && startDate <= now && endDate >= now;
  }

  isDealExpired(deal: MarketDealResponse): boolean {
    const now = new Date();
    const endDate = new Date(deal.end_date);
    return endDate < now;
  }

  isDealUpcoming(deal: MarketDealResponse): boolean {
    const now = new Date();
    const startDate = new Date(deal.start_date);
    return startDate > now;
  }
}
